import type { CourtStatus } from '../types';

interface Props {
  status: CourtStatus;
}

export function StatusBadge({ status }: Props) {
  if (status === 'live') {
    return (
      <span className="status-badge status-live">
        <span className="pulse-dot" />
        LIVE
      </span>
    );
  }
  if (status === 'idle') {
    return <span className="status-badge status-idle">IDLE</span>;
  }
  if (status === 'list_over') {
    return <span className="status-badge status-idle">LIST OVER</span>;
  }
  return <span className="status-badge status-no-data">NO DATA</span>;
}
